import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Senha redefinida com sucesso!");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0D12] px-4">
      <div className="w-full max-w-md bg-[#181F2C] border border-[#263147] rounded-3xl p-8 shadow-2xl animate-fade-up">
        <h1 className="text-xl font-bold font-heading text-slate-100 mb-1">Nova senha</h1>
        <p className="text-sm text-slate-400 mb-6">Defina uma nova senha para sua conta.</p>
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="rp-password" className="text-slate-300">Nova senha</Label>
            <Input
              id="rp-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 bg-[#0F1520] border-[#263147] text-slate-100 rounded-xl focus-visible:ring-emerald-500"
            />
          </div>
          {error && <div className="text-sm text-red-400">{error}</div>}
          <Button type="submit" disabled={loading || !token} className="w-full h-12 bg-emerald-500 hover:bg-emerald-600 text-[#0A0D12] font-semibold rounded-xl">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Redefinir senha"}
          </Button>
          <Link to="/login" className="flex items-center justify-center gap-2 text-emerald-400 hover:text-emerald-300 text-sm">
            <ArrowLeft className="w-4 h-4" /> Voltar ao login
          </Link>
        </form>
      </div>
    </div>
  );
}
